import { usePublishedData } from "../lib/published-data";
import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import servicesStyles from "../styles/services.css?url";
import { DocumentContent } from "../components/document-content";
import { BookingContent } from "../components/services/booking";
import { useShell } from "../lib/document-route";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { loadBooking } from "../server/services";

/** Appointments (/booking): the page the creator composed, with the booking form at its built-in block, or the native page. */
export const Route = createFileRoute("/booking/")({
  loader: async () => {
    const data = await loadBooking();
    if (data.kind === "missing") throw notFound();
    if (data.kind === "redirect") throw redirect({ href: data.to, statusCode: 302 });
    return data;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    const head =
      loaderData.kind === "page"
        ? creatorPageHead(shell, {
            pathname: "/booking",
            title: loaderData.page.seoTitle || loaderData.page.title,
            description: loaderData.page.description,
            noindex: loaderData.private || loaderData.locked || loaderData.page.hideFromSearch,
            preloadImage: loaderData.lead,
          })
        : creatorPageHead(shell, {
            pathname: "/booking",
            title: `Book an appointment | ${shell.creator.name}`,
            description: loaderData.booking.intro,
          });
    return withStylesheet(head, servicesStyles);
  },
  component: Booking,
});

function Booking() {
  const initial = Route.useLoaderData();
  const shell = useShell();
  const { data } = usePublishedData(initial, shell, "/booking", "page");
  const content = <BookingContent booking={data.booking} />;
  return data.kind === "page" ? (
    <DocumentContent data={data} shell={shell} builtIn={content} />
  ) : (
    content
  );
}
